import starIcon from "../../images/star-icon.png";
import Form from "../common/Form";
import useGlobalSettings from "../../hooks/useGlobalSettings";
import { getBackgroundClass } from "../../utils/sectionHelpers";
import DynamicImage from "../common/DynamicImage";
import { Link } from "react-router-dom";
import { HighlightText } from "../common/HighlightText";

const HomeContact = ({ data }) => {
  const { globalData } = useGlobalSettings();
  // const companyInfo = globalData?.companyInfo;

  const settings = data?.Settings || {};

  const backgroundClass = getBackgroundClass(settings.background);
  return (
    <section className={`contact-area ptb-70 ${backgroundClass}`}>
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-9">
            <div className="section-title">
              {data?.subtitle && (
                <span className="sub-title">
                  <img src={starIcon} alt="contact" />
                  {data.subtitle}
                </span>
              )}
              {data?.title && (
                // <h2
                //   dangerouslySetInnerHTML={{
                //     __html: data.title,
                //   }}
                // />
                <h2><HighlightText content={data.title} /></h2>
              )}
              {data?.content && (
                <p
                  dangerouslySetInnerHTML={{
                    __html: data.content,
                  }}
                />
              )}
            </div>
          </div>
        </div>
        <div className="contact-info-area pb-70">
          <div className="row justify-content-center gy-4">
            <div className="col-lg-10 text-center">
              <div className="section-title">
                {data?.description?.map((block, index) => {
                  switch (block.type) {
                    case "paragraph":
                      return (
                        <p key={index}>
                          {block.children.map((c) => c.text).join("")}
                        </p>
                      );

                    case "heading":
                      const Tag = `h${block.level}`;
                      return (
                        <Tag key={index} className="mt-4 mb-3">
                          {block.children.map((c) => c.text).join("")}
                        </Tag>
                      );

                    case "list":
                      return (
                        <ul key={index} className="list-unstyled">
                          {block.children.map((item, i) => (
                            <li key={i} className="features-text">
                              <h4>
                                <i className="flaticon-tick"></i>{" "}
                                {item.children.map((c) => c.text).join("")}
                              </h4>
                            </li>
                          ))}
                        </ul>
                      );

                    default:
                      return null;
                  }
                })}
              </div>
            </div>

            {/* {companyInfo &&
              companyInfo.length > 0 &&
              companyInfo.map((info, i) => (
                <div className="col-lg-4 col-md-6" key={i}>
                  <div className="contact-info-box">
                    <div className="back-icon">
                      {info.infoTitle === "Email" && (
                        <i className="bx bx-envelope"></i>
                      )}
                      {info.infoTitle === "Phone number" && (
                        <i className="bx bx-phone-call"></i>
                      )}
                      {info.infoTitle === "Address" && (
                        <i className="bx bx-map"></i>
                      )}
                    </div>

                    <div className="icon">
                      {info.infoTitle === "Email" && (
                        <i className="bx bx-envelope"></i>
                      )}
                      {info.infoTitle === "Phone number" && (
                        <i className="bx bx-phone-call"></i>
                      )}
                      {info.infoTitle === "Address" && (
                        <i className="bx bx-map"></i>
                      )}
                    </div>

                    <h3>{info.infoTitle}</h3>

                    <p>
                      {info.infoTitle === "Phone number" ? (
                        <a href={`tel:${info.infoText}`}>{info.infoText}</a>
                      ) : info.infoTitle === "Email" ? (
                        <a href={`mailto:${info.infoText}`}>{info.infoText}</a>
                      ) : (
                        info.infoText
                      )}
                    </p>
                  </div>
                </div>
              ))} */}

            {globalData?.email && (
              <div className="col-lg-4 col-md-6 ">
                <div className="contact-info-box">
                  <div className="back-icon">
                    <i className="bx bx-time-five"></i>
                  </div>
                  <div className="icon">
                    <i className="bx bx-time-five"></i>
                  </div>
                  <h3>E-mail Us</h3>
                  <p>
                    <Link to={`mailto:${globalData.email}`}>
                      {globalData.email}
                    </Link>
                  </p>
                </div>
              </div>
            )}
            {globalData?.phone_number && (
              <div className="col-lg-4 col-md-6">
                <div className="contact-info-box">
                  <div className="back-icon">
                    <i className="bx bx-phone-call"></i>
                  </div>
                  <div className="icon">
                    <i className="bx bx-phone-call"></i>
                  </div>
                  <h3>Call Us</h3>
                  <p>
                    <Link to={`tel:${globalData.phone_number}`}>
                      {globalData.phone_number}
                    </Link>
                  </p>
                </div>
              </div>
            )}
            {globalData?.address && (
              <div className="col-lg-4 col-md-6">
                <div className="contact-info-box">
                  <div className="back-icon">
                    <i className="bx bx-map"></i>
                  </div>
                  <div className="icon">
                    <i className="bx bx-map"></i>
                  </div>
                  <h3>Our Address</h3>
                  <p>{globalData.address}</p>
                </div>
              </div>
            )}
          </div>
        </div>
        <div className="row">
          <div className="col-lg-6 col-md-12 align-self-center">
            <div className="contact-image">
              <DynamicImage image={data?.image} />
            </div>
          </div>

          <div className="col-lg-6 col-md-12">
            <div className="contact-form">
              <Form section="bottom" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HomeContact;
